import { Component } from '@angular/core';
import { BrandService } from 'src/app/services/brand.service';

@Component({
  selector: 'mprd-skeleton-overview',
  templateUrl: './skeleton-overview.component.html',
})
export class SkeletonOverviewComponent {
  constructor(private brandService: BrandService) {}

  getPanelClass(): string {
    return this.brandService.isScarlet() ? '' : 'rs-bg-purple3';
  }
}
